import $ from 'jquery';
import 'slick-carousel';
import BaseComponent from './baseComponent';

/**
 * The slider used in the newsroom to present top news, based on slick slider.
 * http://kenwheeler.github.io/slick/
 */
export default class NewsroomSlider extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);
    this.$slider = $('[data-newsroom-slider]');
  }

  /**
     * Initialize the slider.
     */
  init() {
    if (!this.$slider.length) {
      return;
    }

    this.$slider.slick({
      slidesToShow: 1,
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5500,
      infinite: false,
    });

    // Disable autoplay of slider when a video is playing.
    this.$slider.find('[data-video-thumbnail]').on('click', () => {
      this.$slider.slick('slickSetOption', 'autoplay', false, true);
    });
  }
}
